import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type MicrowebSliceState = {
  isMicroweb: boolean;
  isMicrowebStep: boolean;
  isMicrowebOppgave: boolean;
  skjemaTekniskNavn: string | undefined;
  documentGuid: string | undefined;
  taskId: string | undefined;
  avbryturl: string | undefined;
  avbrytarialabel: string | undefined;
  showPromptLoginMessageInMicroweb: boolean;
  showTopMessageInMicroweb: boolean;
  showFormTitle: boolean;
  showSidebar: boolean;
  showNavigator: boolean;
  showStepperInMicroweb: boolean;
  showValidationSummary: boolean;
  showSubmitButton: boolean;
  showSaveButton: boolean;
  showCancelButton: boolean;
  hidebackbutton: string | undefined;
  skjemadata: string | undefined;
};

export const initialState: MicrowebSliceState = {
  isMicroweb: false,
  isMicrowebStep: false,
  isMicrowebOppgave: false,
  skjemaTekniskNavn: undefined,
  documentGuid: undefined,
  taskId: undefined,
  avbryturl: undefined,
  avbrytarialabel: undefined,
  showPromptLoginMessageInMicroweb: false,
  showTopMessageInMicroweb: false,
  showFormTitle: false,
  showSidebar: false,
  showNavigator: false,
  showStepperInMicroweb: true,
  showValidationSummary: false,
  showSubmitButton: false,
  showSaveButton: false,
  showCancelButton: false,
  hidebackbutton: undefined,
  skjemadata: undefined,
};

const microwebSlice = createSlice({
  name: 'microwebSlice',
  initialState,
  reducers: { setMicrowebState: (_, action: PayloadAction<MicrowebSliceState>) => action.payload },
});
export const { setMicrowebState } = microwebSlice.actions;
export default microwebSlice.reducer;

// onNavigateBackMicroweb?: MicrowebStepFormDataCallBack;
// onCompleteMicroweb?: MicrowebStepFormDataCallBack;
// onCancelMicroweb?: MicrowebStepFormDataCallBack;
// sendPendingChangesEvent?: (hasChanges: boolean) => unknown;
